import { TypographyClamped } from '@/components/typography/TypographyClamped';

export function AssetDisplayName({
  displayName,
  variant = 'title-s',
}: {
  displayName: string;
  variant?: 'title-s' | 'title-xs';
}) {
  return (
    <TypographyClamped variant={variant} lines={2}>
      {displayName}
    </TypographyClamped>
  );
}
